import { render, staticRenderFns } from "./GameExplanation.vue?vue&type=template&id=0d2c6bb0&scoped=true&"
import script from "./GameExplanation.vue?vue&type=script&lang=js&"
export * from "./GameExplanation.vue?vue&type=script&lang=js&"
import style0 from "./GameExplanation.vue?vue&type=style&index=0&id=0d2c6bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c6bb0",
  null
  
)

export default component.exports